import moment from 'moment';
import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import OpenModal from '../helper/OpenModal';
import PDFPSPM from './PDFPSPM';
import { useAlert } from "react-alert";

export default function ShowReportPSPM() {
    let alert = useAlert();
    const [reports, setreports] = useState([])

    useEffect(() => {
        getReports()
    }, [])

    const getReports = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getReportPSPM`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setreports(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos del reporte", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    const columns = [
        {
            name: 'Fecha Reporte',
            selector: row => moment(row.info.createdAt).format("LLLL"),
        },
        {
            name: '¿Quien reporta?',
            selector: row => row.info.names || "Anonimo",
        },
        {
            name: 'Telefono Contacto',
            selector: row => row.info.phone,
        },
        {
            name: 'Correo Contacto',
            selector: row => row.info.email,
        },
        {
            name: "Acción",
            button: "true",
            cell: (row) => (
                <>
                    <OpenModal title={`Reporte #${row.info.idreportpspm}`} type="primary" buttontext="Ver" children={<PDFPSPM data={row} />} />
                </>
            ),
        },
    ];

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <div>
            <DataTable
                columns={columns}
                noDataComponent="Sin datos que mostrar"
                data={reports}
                pagination
                paginationComponentOptions={paginationComponentOptions}
            />
        </div>
    )
}
